<template>
  <div class="modal" v-if="seen">
    <div class="deletefile" v-if="!loader">
      <span @click="closebox" class="closefile">
        <img src="@/assets/Close Button.svg" />
      </span>
      <div class="header d-flex justify-content-center align-items-center mt-2">
        <h6><strong>Restore file?</strong></h6>
      </div>
      <div class="cgn text-center my-2">
        <span>Are you want to restore permanently <strong>{{ str_text(name) }}</strong>?</span>
      </div>
      <div class="save">
        <span class="btn-delete-permanently" @click="restore">
          Restore file
        </span>
      </div>
    </div>
    <div class="permanent" v-if="loader">
      <span>Restoring <strong>{{ str_text(name) }}</strong></span>
      <br />
      <span><img src="@/assets/30.gif" /></span>
    </div>
  </div>
</template>
<style scoped>
.header {
  padding: .5em 0 0 0 !important;
}

.header h3 {
  font-size: 22px;
  font-weight: bold;
}

.save {
  margin-top: 0 !important;
}

.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
  font-size: 14px;
}

.deletefile {
  padding: 2em !important;
}

.modal div.deletefile {
  width: 420px !important;
}

.modal div.deletefile div {
  width: 100% !important;
  margin-left: 0 !important;
}

.save {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.save span {
  flex: 1 !important;
}

.save .btn-move-to-trash {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.save .btn-delete-permanently {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.save .btn-delete {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
  top: 13px !important;
  right: 13px !important;
}
</style>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      name: '',
      seen: false,
      index: null,
      loader: false,
      error: false,
      id: null,
      found: false,
      prompt: ''
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOTAL_USED_SPACE'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 40 ? str.substr(0, 40) + '...' : str
    },
    load(index) {
      this.name = this.$store.getters.DIRECTORY_CHILDREN[index].dir
      this.seen = true
      this.index = index
      this.id = this.$store.getters.DIRECTORY_CHILDREN[index].id
    },
    restore() {
      let data = {
        token: cookies.getCookie('token'),
        file_id: this.id
      };

      let that = this

      this.loader = true

      this.$socket.emit('restorefile', data, function (data) {
        if (data.message === 'completed') {
          that.loader = false
          that.seen = false
          let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          that.UPDATE_TOTAL_USED_SPACE(total_space_used)
          that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)
        }

        if (data.message === 'exist') {
          that.loader = false
          that.seen = false
        }

        if (data.data === false) {
          that.seen = false
          that.loader = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    closebox() {
      this.seen = false
      this.loader = false
    }
  }
}
</script>
